export default "__VITE_ASSET__BQK1mcLI__"